import { Spec } from '../core/proto/common.js';

import {
	PaladinAura,
	PaladinJudgement,
} from '../core/proto/paladin.js';
import { t } from '../core/i18n/index.js';

import * as InputHelpers from '../core/components/input_helpers.js';

// Configuration for spec-specific UI elements on the settings tab.
// These don't need to be in a separate file but it keeps things cleaner.

export const AuraSelection = InputHelpers.makeSpecOptionsEnumInput<Spec.SpecHolyPaladin, PaladinAura>({
	fieldName: 'aura',
	label: t('paladin.aura'),
	values: [
		{ name: t('common.none'), value: PaladinAura.NoPaladinAura },
		{ name: 'Devotion Aura', value: PaladinAura.DevotionAura },
		{ name: 'Retribution Aura', value: PaladinAura.RetributionAura },
	],
});

export const JudgementSelection = InputHelpers.makeSpecOptionsEnumInput<Spec.SpecHolyPaladin, PaladinJudgement>({
	fieldName: 'judgement',
	label: t('paladin.judgement'),
	labelTooltip: t('paladin.judgementTooltip'),
	values: [
		{ name: t('common.none'), value: PaladinJudgement.NoJudgement },
		{ name: 'Wisdom', value: PaladinJudgement.JudgementOfWisdom },
		{ name: 'Light', value: PaladinJudgement.JudgementOfLight },
	],
});
